<template>
  <div class="flex min-h-0 flex-1 flex-col">
    <ScrollArea ref="scrollAreaRef" class="min-h-0 flex-1">
      <div class="flex flex-col gap-3 p-5">
        <Button v-if="messages.length > 0" variant="outline" size="sm" class="mx-auto" :disabled="loading" @click="$emit('loadOlder')">
          {{ loading ? 'Loading...' : 'Load older' }}
        </Button>

        <div v-if="loading && messages.length === 0" class="flex flex-col gap-3">
          <Skeleton v-for="index in 5" :key="index" class="h-14 w-2/3 rounded-md" />
        </div>

        <div v-else-if="messages.length === 0" class="flex h-64 items-center justify-center text-sm text-muted-foreground">
          No messages in this conversation.
        </div>

        <ChatMessageThreadItem
          v-for="message in messages"
          :key="message.id"
          :conversation-id="conversationId"
          :message="message"
          :current-user-id="currentUserId"
          :participants="participants"
          @message-action-started="$emit('messageActionStarted')"
          @message-action-failed="(message) => $emit('messageActionFailed', message)"
          @message-updated="(message) => $emit('messageUpdated', message)"
          @message-deleted="(message) => $emit('messageDeleted', message)"
          @message-reaction-added="(payload) => $emit('messageReactionAdded', payload)"
          @message-reaction-removed="(payload) => $emit('messageReactionRemoved', payload)"
        />
      </div>
    </ScrollArea>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'
import { ScrollArea } from '../../../../../../../resources/js/components/ui/scroll-area/index.js'
import { Skeleton } from '../../../../../../../resources/js/components/ui/skeleton/index.js'
import ChatMessageThreadItem from './ChatMessageThreadItem.vue'

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
  messages: {
    type: Array,
    required: true,
  },
  currentUserId: {
    type: [Number, String, null],
    default: null,
  },
  participants: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['loadOlder', 'messageActionStarted', 'messageActionFailed', 'messageUpdated', 'messageDeleted', 'messageReactionAdded', 'messageReactionRemoved'])

const scrollAreaRef = ref(null)

const scrollToBottom = async () => {
  await nextTick()

  const viewport = scrollAreaRef.value?.$el?.querySelector('[data-reka-scroll-area-viewport]')

  if (!viewport) {
    return
  }

  viewport.scrollTop = viewport.scrollHeight
}

watch(
  () => props.messages.at(-1)?.id,
  () => {
    scrollToBottom()
  },
  { immediate: true }
)
</script>
